import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/DashboardConfigurationData'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class DashboardConfigurationDataStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "DashboardConfigurationDataStore",
			variables: false,
		})
	}
}

export async function load_DashboardConfigurationData(params) {
  await initClient()

	const store = new DashboardConfigurationDataStore()

	await store.fetch(params)

	return {
		DashboardConfigurationData: store,
	}
}
